module.exports = {}


//////////////////
// WEBPACK FOOTER
// /home/jenkins/agent/workspace/b-apps_b2c-site_b2c-site_develop/locales/b2c-site-client-de-DE.json
// module id = 1345
// module chunks = 75